import {
	gridGutter1q1dot5,
	gridGutterHalf,
	gridGutter1q3,
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";

export const headingHotels = `
	display: flex;
	align-items: center;
	justify-content: space-between;
	h6{
		flex: 1;
	}
`;

export const linkPartners = `
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: ${gridGutterHalf}px;
    a{
		font-weight: 600;
    }
    i{
		background: #e8f7f5;
		border-radius: 100%;
		transform: rotate(-90deg);
		margin-left: ${gridGutter1q3}px;
    }
    @media(max-width: 767px){
		justify-content: flex-start;
		margin-bottom: 0;
		margin-top: ${gridGutter1q1dot5}px;
}
`;